export function random_decimal(a=0, b=1) {
  return a+(Math.random()*(b-a));
}

export function random_integer(a=0, b=1) {
  return parseInt(random_decimal(a, b));
}